import { render, staticRenderFns } from "./PayOrderDetail.vue?vue&type=template&id=3b1d9f48&scoped=true"
import script from "./PayOrderDetail.vue?vue&type=script&lang=js"
export * from "./PayOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PayOrderDetail.vue?vue&type=style&index=0&id=3b1d9f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d9f48",
  null
  
)

export default component.exports